import { Pipe, PipeTransform } from '@angular/core';
import { SlideAnnouncementData } from './carousel.interface';

@Pipe({
    name: 'slideAnnouncement',
    standalone: true
})
export class SlideAnnouncementPipe implements PipeTransform {
    /**
     * @param data contains all slide announcement data to be processed
     * @param index receives the index of the slide to be processed in the result
     * @returns a concatenated string for itemLabel and itemTitle in the position of the received index data
     */
    transform(data: SlideAnnouncementData, index: number): string {
        const blockDataIndex: any = data?.blockData?.[index];

        if (!blockDataIndex) {
            return '';
        }

        /**
         * We are only considering a carousel of descriptive text
         * modules so far, so we might need to add some other
         * options for a different kind of modules.
         */
        const itemTitle: string = blockDataIndex?.genericText?.title || '';
        const itemLabel: string = (data?.currentItemLabel || '')
            .replace('{CURRENT_INDEX}', `${index + 1}`)
            .replace('{TOTAL_ITEMS}', `${data?.totalItems}`);

        return `${itemLabel}, ${itemTitle}`;
    }
}
